/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-danger */
import { ControlType, FieldType, type ControlProps } from '../../../../Form';
import { parseAddLabel } from '../../utils';
import type { CommonProps } from '../CommonProps';
import { CheckboxToggleCount } from './Toggles';

type GetToggleField = {
  containerName: string;
  fieldName: string;
  labelText?: { __html: string };
  title: string;
  hide: boolean;
  value: any;
  count?: number;
  commonProps: CommonProps;
  disabled?: boolean;
};

const getToggleField = ({
  containerName,
  fieldName,
  labelText,
  title,
  hide,
  value,
  count,
  commonProps,
  disabled,
}: GetToggleField): ControlProps => ({
  control: ControlType.CONTAINER,
  name: containerName,
  top: { text: title },
  controls: [
    {
      control: ControlType.CHECKBOX,
      name: fieldName,
      label: {
        text: (
          <>
            <div className="checkbox-toggle-html" dangerouslySetInnerHTML={labelText} />
            {/* A 0 still renders: the toggle greys out at zero, and the count is what says why. */}
            {count !== undefined && count !== null ? (
              <CheckboxToggleCount countOnTheLeft={!commonProps.isMobile && !commonProps.isSidebar}>
                {parseAddLabel({ withBrackets: !commonProps.isMobile && !commonProps.isSidebar, count })}
              </CheckboxToggleCount>
            ) : null}
          </>
        ),
      },
      value,
      default: false,
      type: FieldType.TOGGLE,
      disabled: commonProps.isWaiting || disabled,
    },
  ],
  hide,
});

export default getToggleField;
